import { render, staticRenderFns } from "./Extraction.vue?vue&type=template&id=274f4891"
import script from "./Extraction.vue?vue&type=script&lang=js"
export * from "./Extraction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports